module.exports = __webpack_public_path__ + "img/gotop.18e0aa8f.png";